import * as Backbone from "backbone";
import _ from "lodash";

export const FavRenameView = Backbone.View.extend({
	className: 'FavRenameView',
	events: {
		'click .FavRenameViewModeButton': 'enterRenameMode',
		'click .FavRenameViewSaveButton': 'save',
		'click .FavRenameViewCancelButton': 'abort'
	},
	initialize: function (options) {
		this.selpan = options.selpan;
		this.status = new Backbone.Model({
			renameMode: false
		});
		this.listenTo(this.status, 'change:renameMode', this.render);
		this.render();
	},
	enterRenameMode: function () {
		this.status.set({renameMode: true});
	},
	save: function () {
		let name = this.$('input').val();
		this.status.set({renameMode: false});
		this.selpan.renameFavKey(name);
	},
	abort: function () {
		this.status.set({renameMode: false});
	},
	template: _.template('<div class="FavRenameViewModeButton MenuItem">\n\t<div class="MenuInline MenuIcon">\n\t\t<i class="fa fa-i-cursor"></i>\n\t</div>\n\t<div class="MenuInline MenuLabel">\n\t\tFavorit umbenennen\n\t</div>\n</div>'),
	templateRenameMode: _.template('<input data-role="none" class="MenuInput" maxlength="100" type="text" placeholder="Name eingeben">\n<div class="MenuButton MenuRight MenuItem FavRenameViewCancelButton">\n\t<div class="MenuInline MenuIcon"><i class="fa fa-times""></i></div>\n\t<div class="MenuInline MenuLabel">Abbrechen</div>\n</div>\n<div class="MenuButton MenuRight MenuItem FavRenameViewSaveButton">\n\t<div class="MenuInline MenuIcon"><i class="fa fa-check""></i></div>\n\t<div class="MenuInline MenuLabel">OK</div>\n</div>\n'),
	render: function () {
		if (this.status.get('renameMode')) {
			this.$el.html(this.templateRenameMode());
			let $input = this.$('input');
			$input.val(this.selpan.status.get('favKey'));
			$input.focus();
		} else {
			this.$el.html(this.template());
		}
	}
});
